<template>
  <ow003 :schema="schema" :applicant="applicant" :student="student" :school="school">
    <template slot="deviationsOrEvents">
      <p>{{ schema.data.deviations.$title }}</p>

      <w-error :model="schema.data.deviations" />

      <template v-for="(item, index) in typeOfDeviations">
        <w-checkbox
          :key="index + '.deviations'"
          :model="schema.data.deviations"
          :value="item.value"
          :title="item.text"
          :show-error="false"
        />
      </template>

      <w-textarea v-if="randomEventsSelected" :model="schema.data.randomEvents" />
    </template>

    <template slot="support">
      <w-checkbox
        v-for="(type, index) of typeOfScholarshipForms"
        :key="'form_' + index"
        :model="schema.data.benefitForm"
        :title="type.text"
        :value="type.value"
      />
    </template>
  </ow003>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { ow003Mixin } from '@/mixins/document/ow003';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';
import Ow003 from './OW-003';

// @vuese
// OW-003 Stypendia
// @group templates
export default {
  components: { Ow003, ...components },
  mixins: [ow003Mixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true },
    // dane ucznia
    student: { type: Object, required: false },
    // dane wnioskodawcy
    applicant: { type: Object, required: false },
    // dane szkoły
    school: { type: Object, required: false }
  },
  computed: {
    isMoneySupportSelected() {
      return this.schema.$model.data.benefitForm.indexOf(1) >= 0;
    },
    isMatterialSupportSelected() {
      return this.schema.$model.data.benefitForm.indexOf(2) >= 0;
    }
  }
};
</script>
